import React, { useEffect, useState } from 'react'
import { message, Skeleton } from 'antd'
import { FaEye } from 'react-icons/fa'
import CustomModal from '../CustomModal/CustomModal'
import { GET } from '../../utils/apis'
import { secureApi } from '../../Config/api'
import { formatDate } from '../../utils/helpers'
import { translations } from '../../utils/constants'

/**
 * Lists the archived versions of a GTFS feed (created on every replace) and
 * lets the user open one read-only via onView(version). Used on the GTFS list
 * and on the GTFS details page.
 */
const GtfsVersionsModal = ({ isVisible, onClose, feed, language, onView }) => {
  const [versions, setVersions] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!isVisible || !feed?.feed_source) return
    const fetchVersions = async () => {
      setLoading(true)
      setVersions([])
      try {
        const response = await secureApi?.get(GET?.GET_GTFS_FEED_VERSIONS, {
          params: { feed_source: feed?.feed_source, organization_id: feed?.organization_id },
        })
        if (response?.success) setVersions(response?.data || [])
        else message.error(response?.message || 'Failed to fetch GTFS versions.')
      } catch (error) {
        message.error('Error fetching GTFS versions.')
      } finally {
        setLoading(false)
      }
    }
    fetchVersions()
  }, [isVisible, feed?.feed_source])

  return (
    <CustomModal
      isVisible={isVisible}
      onClose={onClose}
      title={`${translations[language]?.versions}${feed?.feed_name ? ` — ${feed.feed_name}` : ''}`}
      language={language}
    >
      {loading ? (
        <Skeleton active paragraph={{ rows: 4 }} />
      ) : versions.length === 0 ? (
        <div style={{ padding: '12px 0', color: '#888' }}>-</div>
      ) : (
        versions.map((v) => {
          const isCurrent = v?.version === null || v?.version === undefined
          return (
            <div
              key={v?.feed_source}
              className='gtfs-version-card'
              style={{
                border: `1px solid ${isCurrent ? '#b7eb8f' : '#f0f0f0'}`,
                background: isCurrent ? '#f6ffed' : '#fff',
              }}
            >
              <span
                className='gtfs-version-badge'
                style={{ background: isCurrent ? '#52c41a' : '#722ed1' }}
              >
                {isCurrent ? (translations[language]?.currentVersion || 'Current') : `v${v?.version}`}
              </span>
              <div className='gtfs-version-info'>
                <div className='gtfs-version-title'>
                  {isCurrent ? translations[language]?.activeSince : translations[language]?.replacedOn} {formatDate(v?.replaced_at)}
                </div>
                <div className='gtfs-version-meta'>
                  {translations[language]?.routes}: {v?.lines} · {translations[language]?.trips}: {v?.trips} · {translations[language]?.stops}: {v?.stops}
                </div>
              </div>
              <button
                className='add-button gtfs-version-view'
                onClick={() => onView(v)}
              >
                <FaEye size={13} />
                {translations[language]?.view}
              </button>
            </div>
          )
        })
      )}
    </CustomModal>
  )
}

export default GtfsVersionsModal
